'use client';

import React from 'react';
import { Outlet, Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import ThemeSwitcher from '../common/ThemeSwitcher';

const AuthLayout = () => {
  const { isAuthenticated, loading } = useSelector(state => state.auth);

  // Rediriger vers le tableau de bord si déjà authentifié
  if (isAuthenticated && !loading) {
    return <Navigate to="/dashboard" />;
  }

  // Configuration des congés via variables d'environnement
  const isHolidays = process.env.REACT_APP_IS_HOLYDAYS === 'true';
  const holidaysFrom = process.env.REACT_APP_HOLYDAYS_FROM || '9 août';
  const holidaysTo = process.env.REACT_APP_HOLYDAYS_TO || '17 août';

  // Composant pour l'encadré warning des congés
  const HolidaysWarning = () => {
    if (!isHolidays) return null;

    return (
      <div className="holidays-warning">
        <div className="holidays-warning__icon">
          <svg 
            width="24" 
            height="24" 
            viewBox="0 0 24 24" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <path 
              d="M12 9V13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <div className="holidays-warning__content">
          <h3>Information importante</h3>
          <p>
            Notre entreprise sera fermée du <strong>{holidaysFrom}</strong> au <strong>{holidaysTo}</strong>.
            Les soumissions déposées pendant cette période seront traitées à notre retour.
          </p>
        </div>
      </div>
    );
  };

  return (
    <div className="auth-container">
      <div className="auth-wrapper">
        <div className="auth-sidebar">
          <div className="auth-logo">
            <img src="/logo.png" alt="Alphafusion File Manager" />
            <h1>Alphafusion File Manager</h1>
          </div>
          
          {/* Encadré warning des congés */}
          <HolidaysWarning />

          <div className="auth-info">
            <h2>Plateforme de gestion de fichiers</h2>
            <p>
              Bienvenue sur Alphafusion File Manager, votre solution complète pour le dépôt
              et la gestion de fichiers pour l'impression 3D.
            </p>
            <ul>
              <li>Upload facile de fichiers</li>
              <li>Suivi en temps réel de vos commandes</li>
              <li>Interface d'administration moderne</li>
            </ul>
          </div>
        </div>

        <div className="auth-content">
          <div className="auth-card">
            <Outlet />
            <ThemeSwitcher />
          </div>
        </div>
      </div>

      <footer className="auth-footer">
        <p>&copy; 2025 Alphafusion File Manager. Tous droits réservés.</p>
        <div className="auth-links">
          <Link to="/terms">Conditions d'utilisation</Link>
          <Link to="/privacy">Politique de confidentialité</Link>
        </div>
      </footer>
    </div>
  );
};

export default AuthLayout;